import Failed from './Failed.png';
import ChoosePlanCarousalImg1 from './choose-plan-carousal-img-1.png';
import ChoosePlanCarousalImg2 from './choose-plan-carousal-img-2.png';
import ChoosePlanCarousalImg3 from './choose-plan-carousal-img-3.png';
import ChoosePlanCarousalImg4 from './choose-plan-carousal-img-4.png';
import ChoosePlanCarousalImg5 from './choose-plan-carousal-img-5.png';
import ReplaceCustomerIcon from './replace-customer.png';
import NoOrdersFound from './no-orders-found.png';
import SchemePercentIcon from './scheme_percent.png';
import SchemeDivisionIcon from './scheme_division.png';
import ManualOfferIcon from './manual-offer.png';

export const PNGS = {
  Failed,
  ChoosePlanCarousalImg1,
  ChoosePlanCarousalImg2,
  ChoosePlanCarousalImg3,
  ChoosePlanCarousalImg4,
  ChoosePlanCarousalImg5,
  ReplaceCustomerIcon,
  NoOrdersFound,
  SchemePercentIcon,
  SchemeDivisionIcon,
  ManualOfferIcon,
};
